<!-- <label for="newkeyword">{{vm.text}}</label> -->
<div class="spacer-top">
<span class="input-group" style="display: inline" as-sortable="vm.sortableOptions" ng-model="vm.diagnoses"
      id="sortable-container">
<!--    <span ng-repeat="kw in vm.diagnoses | filter: {active: '!'+false}" as-sortable-item style="display: inline;">-->
    <span ng-repeat="kw in vm.diagnoses" as-sortable-item style="display: inline;">
      <span uib-dropdown>
        <button type="button" as-sortable-item-handle
                class="btn btn-{{kw.col}}" uib-dropdown-toggle
                data-toggle="uib-dropdown"
                aria-haspopup="true" aria-expanded="false">
          <span class="fa fa-eye-slash" ng-show="kw.hideInInvoice === true"></span>
          {{kw.key}} <span class="caret"></span>
        </button>
        <ul uib-dropdown-menu style="min-width: 250px">
          <li>
            <a ng-click="vm.updateColor(kw,'success')">
              <span class="label label-success">{{vm.customlabels['success']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'warning')">
              <span class="label label-warning">{{vm.customlabels['warning']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'danger')">
              <span class="label label-danger">{{vm.customlabels['danger']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'info')">
              <span class="label label-info">{{vm.customlabels['info']}}</span>
            </a>
          </li>
          <li>
            <a ng-click="vm.updateColor(kw,'primary')">
              <span class="label label-primary">{{vm.customlabels['primary']}}</span>
            </a>
          </li>
          <li role="separator" class="divider" uib-dropdown></li>
          <li uib-dropdown>
            <label for="key{{$index}}" style="padding-left: 20px">Diagnose</label>
            <textarea id="key{{$index}}" class="form-control" ng-blur="vm.editKeyword(kw)" ng-model="kw.key"
                      ng-click="$event.stopPropagation()"></textarea>
          </li>
          <li role="separator" class="divider" uib-dropdown></li>
          <li uib-dropdown ng-show="kw.created"><a><span class="label label-default">Erstellt: {{kw.created}}</span></a></li>
          <li uib-dropdown ng-show="kw.updated"><a><span class="label label-default">Geändert: {{kw.updated}}</span></a></li>
          <li role="separator" class="divider" uib-dropdown></li>
          <li uib-dropdown>
            <span style="margin-left: 20px">
              <input id="vis{{$index}}" type="checkbox" class="form-check-input" ng-change="vm.updateInvoiceVisibility(kw); "
                     ng-model="kw.hideInInvoice">&nbsp;In Rechnung verbergen
            </span>
          </li>
          <li ng-hide="!vm.deleteable || kw.col === 'danger'" role="separator" class="divider" uib-dropdown></li>
          <li ng-hide="!vm.deleteable || kw.col === 'danger'">
              <span class="btn btn-danger btn-sm"  style="margin-left: 20px; margin-right: 20px; min-width:210px " ng-really-message="Stichwort wirklich löschen?"
                    ng-really-click="vm.removeKeyword(kw, $index)"><i class="fa fa-remove"></i> Löschen</span>
        </ul>
      </span>
    </span><!-- ng-repeat -->
  </span>

  <form name="vm.formid" ng-submit="vm.addKeyword()">
    <div class="input-group spacer-top">
      <input class="form-control" ng-model="vm.newkeyword" id="newkeyword"
             placeholder="Neue Diagnose ..."
             ng-keyup="$event.keyCode == 13 && vm.addKeyword()"
             ng-blur="vm.addKeyword()"/>
      <span class="input-group-btn">
          <button type="submit" class="btn btn-success"
                  ng-click="vm.addKeyword()"><i class="fa fa-plus"></i></button>
        </span>
    </div>
  </form>
</div>